export const myCandidatesSelector = (state) => state.myCandidatesManagement;
